import { useTranslate } from '@/components/Helpers/Translate'
import { cn } from '@/lib/utils'
import Image from 'next/image'
import React from 'react'

type Props = {
  isSelected: boolean
  imageUrl?: string
  name: string
  isStarred?: boolean
  onClick: () => void
  flavorColors?: string[]
  isQuickAdd: boolean
}

const FlavorTile = ({
  isSelected,
  imageUrl,
  name,
  isStarred,
  onClick,
  flavorColors,
  isQuickAdd,
}: Props) => {
  const { translate } = useTranslate()

  return (
    <div
      role="button"
      tabIndex={0}
      className="relative max-w-[100px]"
      onClick={onClick}
      onKeyDown={(event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          onClick()
        }
      }}
    >
      <div
        style={{
          height: isQuickAdd ? '60px' : '100px',
          width: isQuickAdd ? '60px' : '100px',
        }}
        className={cn(
          'flex cursor-pointer items-center justify-center overflow-hidden rounded-full border-4 border-secondary p-1',
          isSelected ? 'border-secondary' : 'border-white',
        )}
      >
        {isStarred && (
          <Image
            className="absolute -top-0 right-[-5px]"
            src="/icons/star.svg"
            height={25}
            width={25}
            alt={translate('starred')}
          />
        )}
        {imageUrl ? (
          <Image
            className="object-contain"
            src={imageUrl}
            height={isQuickAdd ? 50 : 100}
            width={isQuickAdd ? 50 : 100}
            alt="Natural Lemon + Natural Lemon"
          />
        ) : (
          <div
            style={{ backgroundColor: `${flavorColors?.[0]}` || '' }}
            className={cn('h-full w-full rounded-full')}
          />
        )}
      </div>
      {!isQuickAdd && (
        <div className="mt-1 flex w-full justify-center text-center text-xs italic">
          {name}
        </div>
      )}
    </div>
  )
}

export default FlavorTile
